import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { useBreakpointValue } from '@chakra-ui/react';

const TableDensityContext = createContext({
  density: 'comfortable',
  setDensity: () => {},
});

export function TableDensityProvider({ children }) {
  // Auto-compact on small screens by default
  const autoDensity = useBreakpointValue({ base: 'compact', md: 'comfortable' });
  const [density, setDensity] = useState(autoDensity || 'comfortable');

  useEffect(() => {
    if (autoDensity) setDensity(autoDensity);
  }, [autoDensity]);

  const value = useMemo(() => ({ density, setDensity }), [density]);
  return (
    <TableDensityContext.Provider value={value}>{children}</TableDensityContext.Provider>
  );
}

export function useTableDensity() {
  return useContext(TableDensityContext);
}


